import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const Footer = () => {
  const { t, lp } = useLang();
  return (
    <footer className="bg-[#0f1a10] text-neutral-300">
      <div className="mx-auto max-w-[1200px] px-6 py-16">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-[#1e4620] font-bold text-lg">
                P
              </span>
              <span className="leading-tight">
                <span className="block text-base font-bold text-white">Pure</span>
                <span className="block text-[11px] font-semibold tracking-widest text-neutral-400 -mt-1">INVESTMENTS</span>
              </span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-neutral-400">{t.footer.tagline}</p>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white">{t.footer.navTitle}</h4>
            <ul className="space-y-2.5">
              {t.nav.map((l) => (
                <li key={l.path}>
                  <Link to={lp(l.path)} className="text-sm text-neutral-400 transition-colors hover:text-[#F26522]">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white">{t.footer.contactTitle}</h4>
            <ul className="space-y-3 text-sm text-neutral-400">
              <li className="flex items-center gap-2.5"><Mail className="h-4 w-4 flex-shrink-0 text-[#F26522]" /> {t.contact.email}</li>
              {t.contact.offices.map((o) => (
                <li key={o.city} className="flex items-start gap-2.5">
                  <MapPin className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#F26522]" />
                  <span>
                    <span className="font-semibold text-neutral-300">{o.city}</span>
                    {" \u2013 "}{o.lines[0]}, {o.lines[1]}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-xs text-neutral-500 md:flex-row">
          <p>© {new Date().getFullYear()} Pure Investments. {t.footer.rights}</p>
          <div className="flex gap-5">
            <Link to={lp("/impressum")} className="transition-colors hover:text-neutral-300">{t.footer.imprint}</Link>
            <Link to={lp("/datenschutz")} className="transition-colors hover:text-neutral-300">{t.footer.privacy}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
